import * as React from "react";
const IncidentReportIcon = (props) => (
  <svg
    fill="none"
    height={48}
    viewBox="0 0 48 48"
    width={48}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z"
      fill="url(#incident-report-a)"
    />
    <path
      d="M24.017 21.298a.836.836 0 1 0 0-1.671.836.836 0 0 0 0 1.671ZM28.149 23.413a.835.835 0 1 0-1.182 1.181.835.835 0 0 0 1.182-1.181ZM19.873 23.419a.835.835 0 1 0 1.182 1.181.835.835 0 0 0-1.182-1.181ZM23.424 26.96a.835.835 0 1 0 1.182 1.181.835.835 0 0 0-1.182-1.181ZM23.984 24.843a.836.836 0 1 0 0-1.671.836.836 0 0 0 0 1.67Z"
      fill="#fff"
    />
    <path
      d="M36.315 11.703a6.685 6.685 0 0 0-9.444 0L11.707 26.866a6.674 6.674 0 0 0 0 9.444 6.685 6.685 0 0 0 9.444 0l15.164-15.163a6.674 6.674 0 0 0 0-9.444ZM19.969 35.128a5.013 5.013 0 0 1-7.08 0 5.004 5.004 0 0 1 0-7.08l2.86-2.86 7.08 7.08-2.86 2.86Zm4.042-4.041-7.08-7.081 7.08-7.08 7.08 7.08-7.08 7.08Zm11.122-11.122-2.86 2.86-7.08-7.081 2.86-2.86a5.012 5.012 0 0 1 7.08 0 5.004 5.004 0 0 1 0 7.081Z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="incident-report-a"
        x1={40.512}
        x2={7.584}
        y1={41.472}
        y2={9.072}
      >
        <stop stopColor="#FED557" />
        <stop offset={1} stopColor="#F67E91" />
      </linearGradient>
    </defs>
  </svg>
);
export default IncidentReportIcon;
